<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="modalTitle" style="display: block;" aria-modal="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTitle">
          <ng-container *ngIf="holdType=='single'">Release this transaction</ng-container>
          <ng-container *ngIf="holdType=='merchant'">Release parked merchant</ng-container>
          <ng-container *ngIf="holdType=='terminal'">Release parked terminal</ng-container>
        </h4>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">


        <p *ngIf="holdType=='single'">This action will only release this single transaction</p>
        <p *ngIf="holdType=='merchant'">This action will release all transactions for a merchant excluding transactions that were directly put on hold directly</p>
        <p *ngIf="holdType=='terminal'">This action will release all transactions for a terminal excluding transactions that were directly put on hold directly</p>

        <div class="form-group row">
          <label class="col-3 col-form-label">Release Reason</label>
          <div class="col-9">
            <textarea [(ngModel)]="reason" class="form-control" rows="5"></textarea>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-info waves-effect waves-light mr-1" (click)="closeAndRelease()"><i class="mdi mdi-pause-circle-outline mr-1"></i> <span>Release</span></button>
        <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
